import { useState, useEffect } from 'react';
export var useObservable = function (observable, defaultValue) {
    var _a = useState(defaultValue), value = _a[0], setValue = _a[1];
    var _b = useState(undefined), error = _b[0], setError = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        if (!observable)
            return;
        var sub = observable.subscribe({
            next: function (newValue) {
                setLoading(false);
                setValue(newValue);
            },
            error: function (error) { return setError(error); }
        });
        return function () { return sub.unsubscribe(); };
    }, [observable]);
    return [value, loading, error];
};
//# sourceMappingURL=use-observable.js.map